import SignUp from './SignUp'
import useSignUpPath from './useSignUpPath'

export { useSignUpPath }
export default SignUp
